export enum JobMessageStatus {
    Pending = 'pending',
    Succeeded = 'succeeded',
    Failed = 'failed',
}
